export const BRAND_NAME = "ArchivExpress";
export const PHONE_DISPLAY = "06 85 71 27 82";
export const PHONE_LINK = "+33685712782";
export const EMAIL = "contact@valodec.com";
export const LOGO_URL = "/logos/archivexpress-1.svg";
export const AREA = "Bouches-du-Rhône";
